<template>
	<div class="card ultimos-posts">
		<div class="card-header">
			<svg width="1em" height="1em" viewBox="0 0 11 24">
				<polygon points="0,0 11,12 0,24 6,12" fill="currentcolor"/>
			</svg>
			{{title}}
		</div>
		<ul class="list-categories collapse">
			
			<li v-for="post in posts">
				<a :href="post.link"><i class="fa fa-chevron-right"></i> {{post.title}}</a>
			</li>

		</ul>
	</div>
</template>

<script>
export default{
	name: 'UltimosPosts',
	props: [
		'title',
		'posts'
	]
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Sidebar/UltimosPosts.vue